import { useContext } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './Main.css';

import { ThemeContext } from 'src/Contexts/ThemeContext';

import Header from 'src/Components/HeaderTemplate/Header';
import Dashboard from 'src/Components/ContentTemplate/Dashboard/Dashboard';
import Status from 'src/Components/ContentTemplate/Status/Status';
import AlarmProtocol from 'src/Components/ContentTemplate/AlarmProtocol/AlarmProtocol';
import Documents from 'src/Components/ContentTemplate/Documents/Documents';
import ManagementPage from 'src/Pages/Management/ManagementPage';
import Profile from 'src/Pages/Profile/Profile';

import {
  RouteErrorBoundary,
  DashboardErrorFallback,
  StatusErrorFallback,
  AlarmProtocolErrorFallback,
  DocumentsErrorFallback,
  SettingsErrorFallback,
} from 'src/Components/RouteErrorBoundary';
import { FilePreview } from 'src/Pages/FilePreview';

const DEV_AUTO_LOGIN = import.meta.env.VITE_DEV_AUTO_LOGIN === 'true';

const Main = () => {
  const { DarkTheme } = useContext(ThemeContext);
  const location = useLocation();

  const headerPaths = ['/', '/alarmprotokoll', '/status'];

  return (
    <div className={`main ${DarkTheme && 'dark'}`}>
      <div className="content">
        {headerPaths.includes(location.pathname) && <Header />}
        <Routes>
          {DEV_AUTO_LOGIN ? (
            <>
              <Route path="/" element={<Navigate to="/status" replace />} />
              <Route
                path="/status"
                element={
                  <RouteErrorBoundary fallback={<StatusErrorFallback />} routeName="Status">
                    <Status />
                  </RouteErrorBoundary>
                }
              />
              <Route path="*" element={<Navigate to="/status" replace />} />
            </>
          ) : (
            <>
              <Route
                path="/"
                element={
                  <RouteErrorBoundary fallback={<DashboardErrorFallback />} routeName="Dashboard">
                    <Dashboard />
                  </RouteErrorBoundary>
                }
              />
              <Route
                path="/status"
                element={
                  <RouteErrorBoundary fallback={<StatusErrorFallback />} routeName="Status">
                    <Status />
                  </RouteErrorBoundary>
                }
              />
              <Route
                path="/alarmprotokoll"
                element={
                  <RouteErrorBoundary
                    fallback={<AlarmProtocolErrorFallback />}
                    routeName="Alarm Protocol"
                  >
                    <AlarmProtocol />
                  </RouteErrorBoundary>
                }
              />
              <Route
                path="/dokumente"
                element={
                  <RouteErrorBoundary fallback={<DocumentsErrorFallback />} routeName="Documents">
                    <Documents />
                  </RouteErrorBoundary>
                }
              />
              <Route
                path="/management"
                element={
                  <RouteErrorBoundary fallback={<SettingsErrorFallback />} routeName="Management">
                    <ManagementPage />
                  </RouteErrorBoundary>
                }
              />
              <Route
                path="/preview/:fileId"
                element={
                  <RouteErrorBoundary fallback={<SettingsErrorFallback />} routeName="File Preview">
                    <FilePreview />
                  </RouteErrorBoundary>
                }
              />
              <Route
                path="/profile"
                element={
                  <RouteErrorBoundary fallback={<SettingsErrorFallback />} routeName="Profile">
                    <Profile />
                  </RouteErrorBoundary>
                }
              />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
};

export default Main;
